import { render, staticRenderFns } from "./PurchaseMain.vue?vue&type=template&id=3c1eec21"
import script from "./PurchaseMain.vue?vue&type=script&lang=js"
export * from "./PurchaseMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports